"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopModal = DesktopModal;
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./styles.css"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Record нужно чтобы для упрощения использования в BookingCalendarModal

function DesktopModal(_ref) {
  let {
    children,
    onClose
  } = _ref;
  return /*#__PURE__*/React.createElement(_uiKit.Outside, {
    onOutside: onClose,
    active: true,
    insideRefs: undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['wrapper']
  }, children));
}